import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-skeleton-match-lineups',
  standalone: true,
  imports: [],
  templateUrl: './skeleton-match-lineups.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonMatchLineupsComponent {
  constructor() {}
}
